import { KidsRequiredDetails, ParentRequiredDetailsType } from "types/event/eventStep5"
import { Address } from "types/globalTypes"

export type ObjectId = string

export type VenueType =
  | 'virtaul'
  | 'physical'
  | 'to-be-determined'

export interface Coordinates {
  latitude: number
  longitude: number
}



export interface SpecialSchedule {
  day: string
  startTime: number
  endTime: number
}

// Form values interface (frontend form)
export interface FormValues {
  title: string
  categoryId: string
  venueType: VenueType
  location?: Address
  locationId?: string
  venuUrl?: string
  venueId?: string
  datesOfEvent: string[]
  timings: {
    startTime: number
    endTime: number
    specialSchedules: SpecialSchedule[]
  }
  minGuestsRequired?: number | string
  maxGuestsAllowed?: number | string
  guestsRequiredToIncreaseMax?: number | string
  dailyGuestLimit?: number | string
  coverPhotosIds?: string[]
  deleteObject?: {
    minGuestsRequired?: 1
    maxGuestsAllowed?: 1
    guestsRequiredToIncreaseMax?: 1
    dailyGuestLimit?: 1
  }
}

export interface Step1BodyTypes {
  /** Basic Info */
  title: string
  categoryId: ObjectId
  organizationId: ObjectId
  organizerId: ObjectId
  description?: string

  /** Venue */
  venueType: VenueType
  location?: Address
  locationId?: ObjectId
  venueUrl?: string
  venueId?: ObjectId

  /** Event Schedule */
  datesOfEvent: string[]

  timings: {
    startTime: number
    endTime: number
    specialSchedules: SpecialSchedule[]
  }

  /** Guest Limits (string allowed for inputs) */
  minGuestsRequired?: number | string
  maxGuestsAllowed?: number | string
  guestsRequiredToIncreaseMax?: number | string
  dailyGuestLimit?: number | string

  /** Relations */
  coverPhotosIds?: ObjectId[]

  /** Delete Flags (backend patch helper) */
  deleteObject?: {
    minGuestsRequired?: 1
    maxGuestsAllowed?: 1
    guestsRequiredToIncreaseMax?: 1
    dailyGuestLimit?: 1
  }
}

//step 2
export interface IPhone {
  dialCode: string;   // e.g., "+92" (max 5 chars)
  isoCode: string;    // e.g., "PK" or "PAK" (2-3 chars)
  number: string;     // The actual phone digits
  verified?: boolean; // Default: false in Mongoose
  firebaseId?: string;
}

export interface UpdateEduClassStep2Body {
  website: string;
  email: string;
  phone?: IPhone;
  administratorIds?: ObjectId[];
}

//step 3

export interface UpdateEduClassStep3Body {
  datesOfEvent: string[]; // Array of ISO Date strings
  timings: Timings;
}
export interface Timings {
  startTime: number;
  endTime: number;
  specialSchedules?: SpecialSchedule[];
}

//step 4

export interface Activity {
  isDefault: boolean
  activityId: string
  startTime: string
  endTime: string
}

export interface UpdateClassStep4Body {
  fromTemplate: boolean
  activities: Activity[]
}

//step 4 (create/update activity)
export interface UnitValue {
  value: number;
  unit: string;
}


export interface StorageLocation {
  locationId: string;
  quantity: UnitValue;
}

export interface SupplyItem {
  name: string;
  type: string;
  description: string;
  image: string;
  link: string;
  organizationId: string;
  group: string[];
  groupSize: number;
  noOfTimes: number;
  price: number;
  priceRange: PriceRange;
  weight: UnitValue;
  totalQuantity: number;
  storageLocations: StorageLocation[];
}

export interface CurriculumData {
  duration: number;
  days: string[]; // Typically ISO 8601 strings from JSON
  activityId: string;
  tasks: string[];
  supplies: SupplyItem[];
}

export interface Step4CurriculumPayload {
  isDefault: boolean;
  curriculum: CurriculumData;
}

//step 5

export interface PriceRange {
  min: number
  max: number
}

export interface UpdateClassStep5Body {
  numOfStaff: number
  estimatedUnitStaffSalary: PriceRange
  totalStaffSalary: PriceRange
  venuePrice: number
  estimatedTotalPrice: PriceRange
}


//step 6 (Late Fee)
export interface UpdateStep6LateFeeBody {
  title: string
  price: number
  description: string
  priceUnit: 'day' | 'hour' | 'minute'
  color: string
  imageId: string
}


//step 6 (ticket-status)
export interface UpdateStep6TicketStatusBody {
  status: 'active' | 'disabled' | 'inactive'
  admissionTicketId: string
  additionalOptionId: string
}
export interface CreateClassesDiscountCode {
  code: string;
  type: 'usd' | 'percent';
  discount: number;
  admissionTicketIds?: string[];
  additionalOptionIds?: string[];
  dropInTicketId?: string;
  totalLimit?: number;
  limitPerFamily?: number;
  expiry?: string;
  note?: string;
}
export type DiscountType = 'usd' | 'percent'

export type DiscountStatus = 'active' | 'disabled' | 'archived'


export interface ClassesDiscountCodeResponse {
  _id: string
  code: string
  classId: string
  type: DiscountType
  discount: number
  admissionTicketIds?: string[]
  additionalOptionIds?: string[]
  dropInTicketId?: string
  totalLimit?: number
  limitPerFamily?: number
  expiry?: string
  note?: string
  status: DiscountStatus
  __v?: number
}

export interface ClassesDiscountCodeApiResponse {
  discountCodes: ClassesDiscountCodeResponse[]
  class: any
}

//Late Fee 

export enum PriceUnit {
  day = 'day',
  hour = 'hour',
  minute = 'minute',
}

export interface ClassesLateFee {
  _id?: string
  title: string
  price: number
  description?: string
  priceUnit: PriceUnit;
  color?: string
  imageId?: string
}


//step 7 (Communication)

export interface AuthorizedAdultRequiredDetails {
  profilePhoto: true
  relation: true
  gender: true
  dateOfBirth: true
  email: true
  phoneNumber: true
  homeAddress: true
  allergies: true
  medicalNotes: true
}

export interface UpdateClassStep7Body {
  requiredDocumentIds?: string[]
  itemsToBringIds?: string[]
  faqIds?: string[]
  agreementIds?: string[]
  parentRequiredDetails?: ParentRequiredDetailsType
  kidsRequiredDetails?: KidsRequiredDetails
  authorizedAdultRequiredDetails?: AuthorizedAdultRequiredDetails
  emailTemplateIds?: string[]
  regulationIds?: string[]
}


//step 8 (Settings)

export interface UpdateClassStep8Body {
  security: 'low' | 'medium' | 'high'
  allowDonation: boolean
  preSelectedDonationAmounts: number[]
}


//Update class Status

export enum classStatusEnum {
  Draft = 'draft',
  Public = 'public',
  Archived = 'archived',
  Private = 'private',
  Following = 'following',
  Subscribed = 'subscribed',
  MentorSocial = 'mentor_social',
}

export interface UpdateClassStatusBody {
  status: classStatusEnum
  scheduledAt?: string
}

//Drop-in tickets

export interface Step6DropInTicket {
  name: string;
  price: number;
  priceUnit: PriceUnit;
  color: string;
  description?: string;
}



//Status of Drop-in ticket
export enum TicketStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export interface DropInTicketStatus {
  status: TicketStatus;
  dropInTicketId: string;
}

